
export const generateRelativeLink = ({ businessUrl = "",  bookingLink = "" }) => { 
  const sanitizedBookingLink = bookingLink.toLowerCase().replace(/ /g, "_");
  return `/${businessUrl}/booking/${sanitizedBookingLink}`;
};



export const generateFullLink = (businessUrl, bookingLink) => {
  const url = generateRelativeLink({ businessUrl, bookingLink })
  return `${window.location.origin}${url}`;
};

export const environment = process.env.REACT_APP_ENV; // Access the environment variable  
export const rootBkndPath = window.location.hostname === 'localhost'
  ? 'http://localhost:4000'
  : 'http://10.0.2.2:4000'

export const rootClientPath =
  environment === "local"
    ? "http://localhost:3000"
    :  window.location.origin; 


export const planEnv = (() => {
  switch (environment) {
    case "development":
    case "test":
    case "local":  
    case "stage":
      return "dev"; // Groups "development", "test", "stage" under "dev"
    case "production":
      return "prod";
    default:
      return "dev"; // Fallback in case environment is not recognized
  }
})(); 
